"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var zIndices = {
    "top": 100,
    "focus": 10,
    "higher": 2,
    "high": 1,
    "regular": 0
};
exports.default = zIndices;
//# sourceMappingURL=zIndices.js.map